exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-header{position:relative;height:258px;margin-bottom:24px\n}\n@media screen and (min-width:768px){\n.home-header{margin-bottom:60px;height:480px\n}\n}\n.home-header .features{background-color:rgba(231,62,81,.9);-webkit-transition:-webkit-transform .4s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .4s cubic-bezier(.175,.885,.32,1.275);transition:transform .4s cubic-bezier(.175,.885,.32,1.275);transition:transform .4s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .4s cubic-bezier(.175,.885,.32,1.275);will-change:transform\n}\n.home-header .features,_:-ms-lang(x){-webkit-transition:none;transition:none\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./public/js/components/HomeHeader.vue
// module id = 609
// module chunks = 0